// third-party
import { createSlice } from '@reduxjs/toolkit';

// project imports
import axios2 from 'utils/axios2';
import { dispatch } from '../index';

// ----------------------------------------------------------------------
// const apiHost = 'https://youteach.ai/api'
const apiHost = process.env.REACT_APP_API_URL;
// console.log(apiHost)

const initialState = {
    error: null,
    sitemaps: null,
    urlitems: null
};

const slice = createSlice({
    name: 'sitemap',
    initialState,
    reducers: {
        getSitemap(state, action) {
            state.sitemaps = action.payload;
        },
        getUrlitem(state, action) {
            state.urlitems = action.payload;
        },
        // HAS ERROR
        hasError(state, action) {
            state.error = action.payload;
        }
    }
});

// Reducer
export default slice.reducer;

// ----------------------------------------------------------------------

export function fetchUrlitem(project_name, vector_id) {
    // const formData = new FormData()
    // console.log(project_name, vector_id)
    return async () => {
        try {
            const formData = new FormData();
            const user_token = localStorage.getItem('user_token');
            formData.append('user_token', user_token);
            formData.append('project_name', project_name);
            formData.append('vector_id', vector_id);
            const response = await axios2.post(`/api/urlitem/fetch`, formData);
            dispatch(slice.actions.getUrlitem(response.data));
            // console.log(response.data)
        } catch (error) {
            dispatch(slice.actions.hasError(error));
        }
    };
}

export function removeUrlitem() {
    return () => {
        dispatch(slice.actions.getUrlitem(null));
        dispatch(slice.actions.hasError(null));
    };
}

export function fetchSitemap(storage, project_name, vector_id) {
    // const formData = new FormData()
    return async () => {
        try {
            const formData = new FormData();
            const user_token = localStorage.getItem('user_token');
            formData.append('user_token', user_token);
            formData.append('storage', storage);
            formData.append('project_name', project_name);
            formData.append('vector_id', vector_id);
            const response = await axios2.post(`/api/sitemap/fetch`, formData);
            dispatch(slice.actions.getSitemap(response.data));
        } catch (error) {
            dispatch(slice.actions.hasError(error));
        }
    };
}

export function insertSitemap(storage, project_name, vector_id, sitemap) {
    // const formData = new FormData()
    return async () => {
        try {
            const formData = new FormData();
            const user_token = localStorage.getItem('user_token');
            formData.append('user_token', user_token);
            formData.append('storage', storage);
            formData.append('project_name', project_name);
            formData.append('vector_id', vector_id);
            formData.append('sitemap', sitemap);
            const response = await axios2.post(`/api/sitemap/insert`, formData);
            dispatch(slice.actions.getSitemap(response.data));
        } catch (error) {
            dispatch(slice.actions.hasError(error));
        }
    };
}

export function removeSitemap() {
    return () => {
        dispatch(slice.actions.getSitemap(null));
        dispatch(slice.actions.hasError(null));
    };
}
